import styled from 'styled-components';
import { FlexColumn, FlexSpace } from '@elementary/common-ui/components';
import { Slider, Typography } from '@mui/material';
import {
  fontSize,
  fontWeight,
  radius,
  space,
} from '@elementary/common-ui/style/utils';

const StyledSlider = styled(Slider)<{ $sliderValues: number[] }>`
  & .MuiSlider-track {
    color: ${({ theme }) => theme.palette.chart.score.medium};
    height: 4px;
  }
  & .MuiSlider-thumb {
    height: 20px;
    width: 4px;
    background-color: ${({ theme }) => theme.palette.surface.inverse};
    border-radius: ${radius('lg')};
  }
  & .MuiSlider-rail {
    background: ${({ theme, $sliderValues }) =>
      `linear-gradient(to right, ${theme.palette.chart.score.low} 0% ${$sliderValues[0]}%, ${theme.palette.chart.score.high} ${$sliderValues[1]}% 100%)`};
    opacity: 1;
    height: 4px;
  }
  & .MuiSlider-valueLabel {
    width: 40px;
    height: 21px;
    padding: ${space('sm')};
    border-radius: ${radius('lg')};
    font-size: ${fontSize('sm')};
    line-height: normal;
    background-color: ${({ theme }) => theme.palette.surface.inverse};
    top: 47px;
    &:before {
      display: none;
    }
  }
`;

type Props = {
  sliderValues: number[];
  onChange: (sliderValues: number[]) => void;
};

const ScoreThresholdsSlider = ({ sliderValues, onChange }: Props) => (
  <FlexColumn>
    <Typography
      sx={{
        paddingBottom: space('lg'),
        fontSize: fontSize('lg'),
        fontWeight: fontWeight('medium'),
        lineHeight: 'normal',
      }}
    >
      Score Thresholds
    </Typography>
    <StyledSlider
      $sliderValues={sliderValues}
      valueLabelDisplay="on"
      valueLabelFormat={(x) => `${x}%`}
      value={sliderValues}
      min={0}
      max={100}
      onChange={(_event: Event, eventValues: number[] | number) =>
        onChange(eventValues as number[])
      }
    />
    <FlexSpace>
      <Typography>0</Typography>
      <Typography>100</Typography>
    </FlexSpace>
  </FlexColumn>
);

export default ScoreThresholdsSlider;
